import { Alert } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';

import { useUserState } from '../../../hooks/useUserState';
import { TranslationsKeys } from '../../../locales/translations';

export default function RestrictedAccessBanner() {
  const { userData } = useUserState();
  const { t } = useTranslation(TranslationsKeys.PETITIONS);

  if (userData?.isRegular !== false) {
    return null;
  }

  return (
    <div className="mx-3 mb-3">
      <Alert icon="information" text={t('restrictedAccessBanner')} />
    </div>
  );
}
